/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ShivaGNVertSecuredConfiguration } from '../shiva-gn-vert-secured-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { CliproConnectivityPagedList } from '../models/clipro-connectivity-paged-list';
import { searchCliproConnectivity$Any } from '../fn/clirpo/search-clipro-connectivity-any';
import { SearchCliproConnectivity$Any$Params } from '../fn/clirpo/search-clipro-connectivity-any';
import { searchCliproConnectivity$Json } from '../fn/clirpo/search-clipro-connectivity-json';
import { SearchCliproConnectivity$Json$Params } from '../fn/clirpo/search-clipro-connectivity-json';

@Injectable({ providedIn: 'root' })
export class ClirpoService extends BaseService {
  constructor(config: ShivaGNVertSecuredConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `searchCliproConnectivity()` */
  static readonly SearchCliproConnectivityPath = '/custom/stations/clipro/connectivity/search';

  /**
   * Search clipro connectivity, sortable and filterable by some fields.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `searchCliproConnectivity$Json()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  searchCliproConnectivity$Json$Response(params?: SearchCliproConnectivity$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<CliproConnectivityPagedList>> {
    return searchCliproConnectivity$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * Search clipro connectivity, sortable and filterable by some fields.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `searchCliproConnectivity$Json$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  searchCliproConnectivity$Json(params?: SearchCliproConnectivity$Json$Params, context?: HttpContext): Observable<CliproConnectivityPagedList> {
    return this.searchCliproConnectivity$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<CliproConnectivityPagedList>): CliproConnectivityPagedList => r.body)
    );
  }

  /**
   * Search clipro connectivity, sortable and filterable by some fields.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `searchCliproConnectivity$Any()` instead.
   *
   * This method sends `application/octet-stream` and handles request body of type `application/octet-stream`.
   */
  searchCliproConnectivity$Any$Response(params?: SearchCliproConnectivity$Any$Params, context?: HttpContext): Observable<StrictHttpResponse<CliproConnectivityPagedList>> {
    return searchCliproConnectivity$Any(this.http, this.rootUrl, params, context);
  }

  /**
   * Search clipro connectivity, sortable and filterable by some fields.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `searchCliproConnectivity$Any$Response()` instead.
   *
   * This method sends `application/octet-stream` and handles request body of type `application/octet-stream`.
   */
  searchCliproConnectivity$Any(params?: SearchCliproConnectivity$Any$Params, context?: HttpContext): Observable<CliproConnectivityPagedList> {
    return this.searchCliproConnectivity$Any$Response(params, context).pipe(
      map((r: StrictHttpResponse<CliproConnectivityPagedList>): CliproConnectivityPagedList => r.body)
    );
  }

}
